<template>
	<component v-if="popupItem" :is="popupItem.identify" :id="popupItem.identify" :info="popupInfo" :node="popupItem" :visible="showDialog" @closed="closeWin"></component>
</template>
<script>
import $ from 'jquery'
import async from 'async'
import _ from 'lodash'
import _this from '../../../lib/car/order/popup'

import store_review from '../formTpl/storeReviewWin'


let _p = window.xwCommon,
    pageTitle = _this.title,
    name = _this.name,
    methods = {
    	closeWin(){
    		this.showDialog = false
    	}
    }

export default {
    name, methods, 
    components:{ store_review },
    props:{
    	"visible":{type:Boolean, default:false },
    	"info":{type:Object, required:true}
    },
    computed:{
    	popupInfo(){
    		return this.info;
    	}
    },
    data: () => { return {
    	pageTitle, showDialog:false, popupItem:null
    } },
    watch:{
        visible:function(val){
            if(val){
                _this.initWin(this).catch((err) => {
                    if(err) this.$alert(err.toString(),pageTitle)
                })
            }else
                this.showDialog = false
        },
        showDialog:function(val){
            if(!val) this.$emit('closed')
        }
    },
    mounted(){
        //_this.initArea(this).then()
    }
}
</script>


// WEBPACK FOOTER //
// popup.vue?121ed2f7